//store.ts
import { configureStore } from '@reduxjs/toolkit';
import {
  patientManagementReducer,
  organisationManagementReducer,
  newChatReducer,
  healthPlanReducer,
  roleManagementReducer,
  doctorManagementReducer,
  departmentManagementReducer,
  paginationReducer
} from 'data';

import { combineReducers } from 'redux';

// Combine reducers
const rootReducer = combineReducers({
  newChat: newChatReducer,
  healthPlan: healthPlanReducer,
  roleManagement: roleManagementReducer,
  doctorManagement: doctorManagementReducer,
  patientManagement: patientManagementReducer,
  organisationManagement: organisationManagementReducer,
  departmentManagement: departmentManagementReducer,
  pagination: paginationReducer
});

// Create the Redux store
const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false
    })
});
export default store;

export type RootState = ReturnType<typeof rootReducer>;

export type AppDispatch = typeof store.dispatch;
